import axios from 'axios'
import { ApiConfig } from '../../../config/api'
import { WebhookSubscriber } from '../../../interfaces/Webhook'

export const getWebhook = (webhookSubscriberId: number) => {
  const url = new URL(`${ApiConfig.WebhookApi}/${webhookSubscriberId}`)

  return axios.get(url.toString())
}

export const updateWebhook = (
  webhookSubscriberId: number,
  dto: WebhookSubscriber
) => {
  const url = new URL(`${ApiConfig.WebhookApi}/${webhookSubscriberId}`)

  return axios.put(url.toString(), dto)
}
